// Bulb-matrix SVG renderer for live timer updates on the Flash Sale scoreboard.
// Mirrors snippets/flash-sale-bulb-digits.liquid — keep them in sync.

(function () {
  const GLYPHS = {
    '0': ['01110','10001','10011','10101','11001','10001','01110'],
    '1': ['00100','01100','00100','00100','00100','00100','01110'],
    '2': ['01110','10001','00001','00010','00100','01000','11111'],
    '3': ['11110','00001','00001','01110','00001','00001','11110'],
    '4': ['00010','00110','01010','10010','11111','00010','00010'],
    '5': ['11111','10000','11110','00001','00001','10001','01110'],
    '6': ['00110','01000','10000','11110','10001','10001','01110'],
    '7': ['11111','00001','00010','00100','01000','01000','01000'],
    '8': ['01110','10001','10001','01110','10001','10001','01110'],
    '9': ['01110','10001','10001','01111','00001','00010','01100'],
    ':': ['00000','00100','00100','00000','00100','00100','00000'],
    '$': ['00100','01111','10100','01110','00101','11110','00100'],
    ' ': ['00000','00000','00000','00000','00000','00000','00000'],
    'A': ['01110','10001','10001','11111','10001','10001','10001'],
    'E': ['11111','10000','10000','11110','10000','10000','11111'],
    'F': ['11111','10000','10000','11110','10000','10000','10000'],
    'H': ['10001','10001','10001','11111','10001','10001','10001'],
    'L': ['10000','10000','10000','10000','10000','10000','11111'],
    'S': ['01111','10000','10000','01110','00001','00001','11110'],
  };

  function renderBulbs(text, opts) {
    opts = opts || {};
    const color = opts.color || '#ffe9b8';
    const dim = opts.dimColor || 'rgba(255,140,40,.10)';
    const r = opts.bulbR || 1.8;
    const sp = opts.spacing || 4.4;
    const gap = opts.charGap || 3;
    const idSuffix = opts.idSuffix || ('fs' + Math.random().toString(36).slice(2, 8));
    const charW = 5 * sp;
    const totalW = text.length * charW + Math.max(0, text.length - 1) * gap + 2 * r;
    const totalH = 7 * sp + 2 * r;
    const parts = [
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${totalW.toFixed(1)} ${totalH.toFixed(1)}" width="100%" style="display:block;max-height:${(totalH * 1.2).toFixed(0)}px">`,
      `<defs><filter id="glow_${idSuffix}" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="1.2" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>`,
    ];
    let x = r;
    for (const ch of text) {
      const g = GLYPHS[ch] || GLYPHS[' '];
      for (let row = 0; row < 7; row++) {
        for (let col = 0; col < 5; col++) {
          const cx = x + col * sp + r;
          const cy = r + row * sp + r;
          if (g[row][col] === '1') {
            parts.push(`<circle cx="${cx.toFixed(2)}" cy="${cy.toFixed(2)}" r="${r}" fill="${color}" filter="url(#glow_${idSuffix})" opacity="0.95"/>`);
          } else {
            parts.push(`<circle cx="${cx.toFixed(2)}" cy="${cy.toFixed(2)}" r="${(r * 0.55).toFixed(2)}" fill="${dim}"/>`);
          }
        }
      }
      x += charW + gap;
    }
    parts.push('</svg>');
    return parts.join('');
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function fmtRemaining(endAtMs) {
    const ms = Math.max(0, endAtMs - Date.now());
    const total = Math.floor(ms / 1000);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function startTimer(el, endAtIso, color) {
    const endAtMs = new Date(endAtIso).getTime();
    function tick() { el.innerHTML = renderBulbs(fmtRemaining(endAtMs), { color: color }); }
    tick();
    return setInterval(tick, 1000);
  }

  window.PoFlashBulbs = { renderBulbs, fmtRemaining, startTimer };
})();
